import React, { useCallback } from 'react';
import { Modal } from 'antd';
import moment from 'moment';
import { navigate } from 'gatsby';
import InfoCircleFilled from '@ant-design/icons/InfoCircleFilled';
import { apis, api, inWindow, util, NotificationReadFlag, conf, } from 'api';
import { config, ruleEngine, SiteURLMap } from 'env_def';
import { getIn18Text } from 'api';
import { useAppSelector } from '@web-common/state/createStore';
import toast from '@web-common/components/UI/Message/SiriusMessage';
import { safeDecodeURIComponent as _safeDecodeURIComponent } from './safeDecodeURIComponent';
import { PageLoading } from '@web-common/components/UI/Loading';
import { WAIMAO_PRODUCT_VERSIONS } from '@web-common/conf/waimao/constant';
import { getWaimaoTrailEntryHost as _getWaimaoTrailEntryHost } from './getWaimaoTrailEntryHost';
export * from './menuUtils';
const productAuthApi = api.requireLogicalApi(apis.productAuthApiImpl);
const trackerApi = api.requireLogicalApi('dataTrackerApiImp');
const siteApi = api.requireLogicalApi(apis.siteApiImpl);
const eventApi = api.getEventApi();
const systemApi = api.getSystemApi();
const inElectron = systemApi.isElectron();
const isWebWmEntry = systemApi.isWebWmEntry();
const isDev = () => inWindow() && ((window === null || window === void 0 ? void 0 : window.location.href.includes('su-desktop-web')) || (window === null || window === void 0 ? void 0 : window.location.href.includes('su-desktop-web.office.163.com')));
export const lookLikeInElectron = inElectron || (isDev() && !isWebWmEntry);
export const showDialog = ({ title, content }) => {
    Modal.warning({
        icon: [React.createElement(InfoCircleFilled, { style: { color: title ? '#F74F4F' : '#386EE7', marginRight: '9px' }, rev: undefined })],
        title: title || getIn18Text('TISHI'),
        content,
        okText: getIn18Text('ZHIDAOLE'),
        width: '480px',
        className: 'sirius',
        centered: true,
    });
};
export { base64DecToArr } from './image';
export const truncate = (val = '', len, ellipsis) => {
    let str = '';
    let n = 0;
    len *= 2;
    for (const char of val) {
        n += (char.codePointAt(0) || 0) > 256 ? 2 : 1;
        if (n === len) {
            str += char;
            break;
        }
        else if (n > len) {
            break;
        }
        str += char;
    }
    return str !== val ? str + (ellipsis || '') : str;
};
export const truncateMiddle = (val = '', preLen, postLen) => {
    let n = 0;
    for (const char of val) {
        n += (char.codePointAt(0) || 0) > 256 ? 2 : 1;
    }
    if (n > (preLen + postLen) * 2) {
        const reversed = val.split('').reverse().join('');
        return `${truncate(val, preLen)}...${truncate(reversed, postLen).split('').reverse().join('')}`;
    }
    return val;
};
export const parseShareUrlParams = (hash) => {
    try {
        const params = {};
        hash
            .replace('#', '')
            .split('&')
            .forEach(param => {
            const [key, value] = param.split('=');
            if (key === 'type') {
                params[key] = value === 'file' ? 'FILE' : 'DIRECTORY';
            }
            else if (key === 'from') {
                if (value === 'QIYE') {
                    params[key] = 'ent';
                }
                else if (value === 'PERSONAL') {
                    params[key] = 'personalShare';
                }
            }
            else if (key === 'id' || key === 'parentResourceId') {
                params[key] = +value;
            }
            else {
                params[key] = value;
            }
        });
        return params;
    }
    catch (error) {
        trackerApi.track('pc_disk_view_error', {
            type: 'parseShareUrlParams',
            hash,
        });
    }
    return {};
};
export const parseUrlObjectParams = (hash) => {
    const params = {};
    hash
        .replace('#', '')
        .split('&')
        .forEach(param => {
        const [key, value] = param.split('=');
        params[key] = value;
    });
    return params;
};
export const getParameterByName = (name, url = location.href) => {
    try {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
        if (!results)
            return null;
        if (!results[2])
            return '';
        return safeDecodeURIComponent(results[2].replace(/\+/g, ' '));
    }
    catch (error) {
        trackerApi.track('pc_disk_view_error', {
            type: 'getParameterByName',
            url,
            error,
        });
    }
    return '';
};
export const downloadFileInBrowser = (url) => {
    const eleLink = document.createElement('a');
    eleLink.download = 'dl';
    eleLink.style.display = 'none';
    eleLink.href = url;
    document.body.appendChild(eleLink);
    eleLink.click();
    document.body.removeChild(eleLink);
};
export const idIsTreadMail = (id) => {
    if (id) {
        try {
            const mailIdReg = /\d+/;
            const [realId] = id.split('--') || [''];
            const [res] = mailIdReg.exec(realId) || [null];
            if (res && res.length === realId.length) {
                return true;
            }
        }
        catch (_a) {
            return false;
        }
        return false;
    }
    return false;
};
export const getAuthConfig = (key) => {
    return productAuthApi.getAuthConfig(key);
};
export const getIfHaveAuth = (key) => {
    if (key) {
        const config = productAuthApi.getAuthConfig(key);
        if (config && config.show) {
            return true;
        }
    }
    return false;
};
export const comIsShowByAuth = (key, com) => {
    if (key && com) {
        const config = productAuthApi.getAuthConfig(key);
        if (config && config.show) {
            if (typeof com === 'function') {
                return com(config);
            }
            else {
                return com;
            }
        }
    }
    return React.createElement(React.Fragment, null);
};
export const getValidStoreWidth = (storeData) => {
    if (storeData.suc && storeData.data && /^\d+$/.test(storeData.data)) {
        return Number(storeData.data);
    }
    return 0;
};
export class FetchLock {
    constructor() {
        this.fetchId = 0;
    }
    setFetchId() {
        this.fetchId += 1;
        return this.fetchId;
    }
    getFetchId() {
        return this.fetchId;
    }
}
export const getJumpType = (page = 'acquisition') => {
    const CONFIG = {
        acquisition: 1,
        customsBigData: 2,
        mailMarketing: 3,
        website: 4,
        mediaMarketing: 5,
        globalSearch: 6,
        mailHLogin: 7,
    };
    return CONFIG[page] || CONFIG.acquisition;
};
export const getWaimaoTrailEntryHost = _getWaimaoTrailEntryHost;
export const getWaimaoEntryHost = () => {
    const stage = conf('stage');
    const isProd = ['prod', 'prev'].includes(stage);
    const waimaoEntry = {
        test: 'https://waimao-test2.cowork.netease.com/',
        prod: 'https://waimao.office.163.com/',
    };
    return waimaoEntry[isProd ? 'prod' : 'test'];
};
export const getJumpOutRedirectUrl = (sid, page) => {
    if (!inWindow() || !sid) {
        return '';
    }
    const query = `jumpMode=jumpOut&jumpType=${getJumpType(page)}&sid=${sid}&from=${window.location.href}`;
    const host = getWaimaoTrailEntryHost();
    const url = window.location.hash.includes('static/sirius-web') ? `static/sirius-web/jump/?${query}` : `jump/?${query}`;
    return host + encodeURIComponent(url);
};
export const getLingXiEntryHost = () => {
    const stage = config('stage');
    const isProd = ['prod', 'prev'].includes(stage);
    const lingXiEntry = {
        test: 'https://sirius-desktop-web.cowork.netease.com/',
        prod: 'https://lingxi.office.163.com/',
    };
    return lingXiEntry[isProd ? 'prod' : 'test'];
};
export const getWaimaoTrailJumpUrl = (code, redirectUrl) => {
    const host = getWaimaoTrailEntryHost();
    const path = 'it-others/api/pub/login/jump/';
    return `${host}${path}?code=${code}&redirectUrl=${redirectUrl}`;
};
export const isWebmail = () => {
    if (!inWindow() || !config('profile')) {
        return false;
    }
    return config('profile').toString().includes('webmail');
};
export const refreshPage = () => {
    systemApi.switchLoading(true);
    util.reload();
};
export const sendLogout = () => {
    setTimeout(() => {
        eventApi.sendSysEvent({
            eventName: 'logout',
            eventData: {
                jumpTo: 'login',
                clearCookies: false,
            },
        });
    }, 500);
};
export const setLoginBlock = (isBlock) => {
    eventApi.sendSysEvent({
        eventName: 'loginBlock',
        eventData: isBlock,
        eventSeq: 0,
    });
};
export const openWebUrlWithLoginCode = (url) => {
    if (systemApi.isElectron()) {
        const webHost = config('host');
        siteApi
            .genLoginCode()
            .then(code => {
            systemApi.openNewWindow(`${webHost}/site/api/pub/login/jump?code=${code}&redirectUrl=${encodeURIComponent(url)}`, false);
        })
            .catch(e => {
            console.error(e);
            systemApi.openNewWindow(url, false);
        });
    }
    else {
        window.open(url, '_blank');
    }
};
export const requestInQueue = (timeout) => {
    let running = false;
    const requestQueue = [];
    const start = (request) => {
        requestQueue.push(request);
        run();
    };
    const run = () => {
        if (running) {
            return;
        }
        running = true;
        const current = requestQueue.shift();
        if (current) {
            const timeoutId = setTimeout(() => {
                console.log('Request timed out');
                running = false;
                clearTimeout(timeoutId);
                run();
            }, timeout);
            const promise = current();
            if (promise.finally) {
                promise.finally(() => {
                    clearTimeout(timeoutId);
                    running = false;
                    run();
                });
            }
            else {
                console.error('Request does not return a promise');
                clearTimeout(timeoutId);
                running = false;
                run();
            }
        }
        else {
            running = false;
        }
    };
    return start;
};
export const safeDecodeURIComponent = _safeDecodeURIComponent;
export const compareWmVersion = (prev, next) => {
    const prevVersion = prev.split('.');
    const nextVersion = next.split('.');
    if (prevVersion.length !== 3 || nextVersion.length !== 3) {
        throw new Error('compareWmVersion error');
    }
    if (prev === next) {
        return 0;
    }
    for (let i = 0; i < prevVersion.length; i++) {
        if (prevVersion[i] !== nextVersion[i]) {
            return prevVersion[i] > nextVersion[i] ? 1 : -1;
        }
    }
    return 0;
};
export const getOfficialWebsiteHost = () => config('officialWebsiteHost') || 'https://waimao.163.com';
export const getHelpCenterHost = () => config('helpCenterHost') || 'https://waimao.office.163.com';
export const openHelpCenter = (url = '') => {
    if (url && url.startsWith('http')) {
        systemApi.openWaimaoUrlWithLoginInfo(url);
    }
    else {
        const host = getHelpCenterHost();
        systemApi.openWaimaoUrlWithLoginInfo(`${host}/helpCenter${url && url.startsWith('/') ? url : '/' + url}`);
    }
};
export const useOpenHelpCenter = () => {
    const version = useAppSelector(state => state.privilegeReducer.version);
    const navigateVersion = useAppSelector(state => state.privilegeReducer.navigateVersion);
    return useCallback((url) => {
        if (navigateVersion) {
            toast.warn('您使用的是企业邮箱领航版，无法查看知识中心，请联系商务同事购买外贸通正式版本');
            return;
        }
        if (version === WAIMAO_PRODUCT_VERSIONS.FREE) {
            toast.warn('您使用的是体验版，无法查看知识中心，请联系商务同事购买外贸通正式版本');
            return;
        }
        if (version === WAIMAO_PRODUCT_VERSIONS.FASTMAIL_EXPIRED) {
            toast.warn('您购买的外贸通已过期，无法查看帮助中心，请联系商务同事续费以方便查看知识中心');
            return;
        }
        return openHelpCenter(url);
    }, [version]);
};
export const formatSize = (size) => {
    try {
        const units = ['KB', 'MB', 'GB', 'TB'];
        const base = 1024;
        let value = size;
        if (value < base) {
            return value + 'B';
        }
        let i = 0;
        while (value >= base && i < units.length) {
            value = value / base;
            i++;
        }
        return parseFloat(value.toFixed(2)) + units[i - 1];
    }
    catch (error) {
        console.error('[error]formatSize error:', error);
        return '';
    }
};
export const pushNavigateCrossMultiClient = (url, internalJump = true) => {
    if (url === '/#wmData?page=star') {
        url = '/#customsData?page=star';
    }
    if (systemApi.isWebWmEntry()) {
        if (url.split('?')[0].indexOf('unitable-crm') > -1) {
            systemApi.openNewWindow(url);
        }
        else if (url.indexOf('#mailbox') > -1) {
            systemApi.openNewWindow(url);
        }
        else {
            const destinationUrl = ruleEngine(url, null) || url;
            systemApi.openNewWindow(destinationUrl);
        }
    }
    else {
        if (url.indexOf('#globalSearch') > -1) {
            url = url.replace('#globalSearch', '#wmData');
        }
        if (url.indexOf('#customsData') > -1) {
            url = url.replace('#customsData', '#wmData');
        }
        if (!internalJump || url.startsWith('http')) {
            systemApi.openNewWindow(url);
        }
        else {
            navigate(url);
        }
    }
};
export const batchDeleteNoticeList = (noticeList, ids) => noticeList.reduce((total, current) => {
    const newItems = current.items.filter(v => !ids.includes(v.id));
    total.push(Object.assign(Object.assign({}, current), { items: newItems }));
    return total;
}, []);
export const batchMarkReadNoticeList = (noticeList, ids) => {
    return noticeList.reduce((total, current) => {
        const newItems = current.items.map(v => {
            let readFlag = v.readFlag;
            if (!ids) {
                readFlag = NotificationReadFlag.READ;
            }
            else if (readFlag !== NotificationReadFlag.READ) {
                readFlag = ids.includes(v.id) ? NotificationReadFlag.READ : NotificationReadFlag.UNREAD;
            }
            return Object.assign(Object.assign({}, v), { readFlag });
        });
        total.push(Object.assign(Object.assign({}, current), { items: newItems }));
        return total;
    }, []);
};
export const getPolyvChannelId = (url) => {
    const matched = url.match(/live.polyv.cn\/watch\/(\d+)/);
    return matched && matched.length > 1 ? matched[1] : '';
};
export const isValidRedirectUrl = (url) => {
    if (url.startsWith('/') || url.startsWith('#')) {
        return true;
    }
    try {
        const whiteList = ['netease.com', '163.com'];
        const urlObj = new URL(url);
        return whiteList.some(v => urlObj.host.endsWith(v));
    }
    catch (e) {
        console.error('invalid redirect url', url);
        return false;
    }
};
export const jumpToRedirectUrl = (url, type = 'assign', fallbackUrl = '/') => {
    if (type === 'assign') {
        window.location.assign(isValidRedirectUrl(url) ? url : fallbackUrl);
    }
    else {
        window.location.replace(isValidRedirectUrl(url) ? url : fallbackUrl);
    }
};
export const getModuleByPermission = (label) => {
    const resKey = Object.keys(SiteURLMap).find(key => SiteURLMap[key].sub_module_permission_label === label);
    const res = resKey ? SiteURLMap[resKey] : null;
    if (res) {
        if (inElectron) {
            if (res.url.endsWith('addressBookDatastat')) {
                return Object.assign(Object.assign({}, res), { url: '#edm?page=contact' });
            }
            return Object.assign(Object.assign({}, res), { url: res.url.replace(/#intelliMarketing\?page=/, '#edm?page=') });
        }
        return res;
    }
    return null;
};
export const requestCompHoc = (useRequestHooks, CompA, CompB) => {
    const { visible, loading } = useRequestHooks();
    if (loading) {
        return React.createElement(PageLoading, { style: { top: 54 } });
    }
    if (visible) {
        return React.createElement(CompA, null);
    }
    return React.createElement(CompB, null);
};
export const navigateWithSearchQuery = (to, options) => {
    let queryStr = '';
    if (typeof window !== 'undefined') {
        if (location.search) {
            const postfix = '/';
            queryStr = location.search.indexOf(postfix) === location.search.length - 1 ? location.search : location.search + postfix;
            const toHasPostFix = to.indexOf(postfix) === 0;
            if (toHasPostFix) {
                queryStr = queryStr.replaceAll(postfix, '');
            }
        }
    }
    navigate(queryStr + to, options);
};
export const loadScript = (url, options = {}) => new Promise((resolve, reject) => {
    var _a;
    const existingScript = document.querySelector(`script[src="${url}"]`);
    if (existingScript) {
        if (existingScript.dataset.loaded === 'true') {
            resolve(existingScript);
            return;
        }
        existingScript.addEventListener('load', () => resolve(existingScript));
        existingScript.addEventListener('error', () => reject(new Error(`Failed to load script: ${url}`)));
        return;
    }
    const script = document.createElement('script');
    script.src = url;
    script.async = (_a = options.async) !== null && _a !== void 0 ? _a : true;
    if (options.type)
        script.type = options.type;
    if (options.crossOrigin)
        script.crossOrigin = options.crossOrigin;
    if (options.integrity)
        script.integrity = options.integrity;
    script.onload = () => {
        script.dataset.loaded = 'true';
        resolve(script);
    };
    script.onerror = () => {
        script.remove();
        reject(new Error(`Failed to load script: ${url}`));
    };
    const target = options.target || document.head;
    target.appendChild(script);
});
export const formatDuration = (seconds, conf) => {
    const { inEnglish } = conf || {};
    const duration = moment.duration(seconds, 'seconds');
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();
    const minutes = duration.minutes();
    const secs = duration.seconds();
    let result = '';
    if (days > 0) {
        result += `${days}${inEnglish ? 'd ' : getIn18Text('TIAN')}`;
    }
    if (hours > 0) {
        result += `${hours}${inEnglish ? 'h ' : getIn18Text('XIAOSHI')}`;
    }
    if (minutes > 0) {
        result += `${minutes}${inEnglish ? 'm ' : getIn18Text('分')}`;
    }
    if (secs > 0 || result === '') {
        result += `${secs}${inEnglish ? 's' : getIn18Text('MIAO')}`;
    }
    return result;
};
export const webTabOpen = (url) => {
    let cloudUrl = document.createElement('a');
    const href = url;
    cloudUrl.href = href;
    cloudUrl.target = '_blank';
    cloudUrl.click();
};
function generateUniqueId() {
    const timestamp = new Date().getTime();
    const random = Math.floor(Math.random() * 1000000);
    return `${timestamp}-${random}`;
}
export const RDB_CLIENT_ID = generateUniqueId();
export const navigateToEdm = (query) => {
    let queryStr = query;
    if (query) {
        queryStr = query.startsWith('?') ? query : '?' + query;
    }
    navigate(`#${inElectron ? 'edm' : 'intelliMarketing'}${queryStr}`);
};
export const getNoContactTime = (time) => {
    if (!time) {
        return;
    }
    const day = 24 * 60 * 60 * 1000;
    const now = Date.now();
    const daysArr = [7, 15, 30];
    for (let i = 0; i < daysArr.length; i++) {
        if (now - time < daysArr[i] * day) {
            return `近${daysArr[i]}天联系过`;
        }
    }
};
